'use client'

import {createContext, useContext, useState, ReactNode} from 'react'
import {TagId} from '@app/[lang]/(common-header-footer)/tags/types'

export interface TagsPageAnalyticsData {
  'tag-name'?: string
  'tag-id'?: TagId
}

const TagsPageAnalyticsContext = createContext<{
  tagAnalyticsData: TagsPageAnalyticsData
  setTagAnalyticsData: (newData: TagsPageAnalyticsData) => void
} | null>(null)

export const TagsPageDataProvider: React.FC<{children: ReactNode}> = ({children}) => {
  const [tagAnalyticsData, setTagAnalyticsData] = useState<TagsPageAnalyticsData>({})

  return (
    <TagsPageAnalyticsContext.Provider value={{tagAnalyticsData, setTagAnalyticsData}}>
      {children}
    </TagsPageAnalyticsContext.Provider>
  )
}

export const useTagsPageAnalytics = () => {
  const context = useContext(TagsPageAnalyticsContext)

  if (!context) {
    return {
      tagAnalyticsData: {},
      setTagAnalyticsData: () => {},
    }
  }

  return context
}
